export enum BlogSectionsEnum {
  posts = 'posts',
  pages = 'pages',
  categories = 'categories',
}

export enum BlogSectionsTitleEnum {
  posts = 'dashboard.blog.posts.title_plural',
  pages = 'dashboard.blog.pages.title_plural',
  categories = 'dashboard.blog.categories.title_plural',
}
